import { render, staticRenderFns } from "./DiagnosisIcon.vue?vue&type=template&id=19ae47bc&scoped=true&"
import script from "./DiagnosisIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiagnosisIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae47bc",
  null
  
)

export default component.exports